import './utils/globalFetchAuth';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
export { default as ChallengeArena } from './components/Challenge/ChallengeArena';

// ============================================================
// ✅ گارد ۱: promise های بدون catch
// ============================================================
window.addEventListener('unhandledrejection', (e) => {
  console.error('🚨 Unhandled promise rejection:', e.reason);
});

// ============================================================
// ✅ گارد ۲: خطای chunk بعد از deploy جدید → reload خودکار (فقط یک بار)
// ============================================================
window.addEventListener('error', (e) => {
  const msg = String(e?.message || '');
  if (
    /Loading chunk .* failed/i.test(msg) ||
    /ChunkLoadError/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg)
  ) {
    const key = 'chunk_reload_attempted';
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      window.location.reload();
    }
  }
});

// ============================================================
// ✅ گارد ۳: بعد از لود موفق، flag رو پاک کن تا deploy بعدی هم کار کنه
// ============================================================
setTimeout(() => {
  try { sessionStorage.removeItem('chunk_reload_attempted'); } catch {}
}, 5000);

// ============================================================
// ✅ رندر اصلی + ErrorBoundary سراسری (آخرین خط دفاعی)
// ============================================================
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <AuthProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </AuthProvider>
  </ErrorBoundary>
);